import React from 'react';
import { DocumentTextIcon, ArrowRightIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

export const Documents: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center">
        <DocumentTextIcon className="h-16 w-16 mx-auto text-gray-300 mb-4" />
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Document Management</h2>
        <p className="text-gray-600 mb-6 max-w-md mx-auto">
          Documents are now managed within each client engagement.
          Navigate to a specific engagement to view and manage project documents.
        </p>
        <Link
          to="/portal/engagements"
          className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          Go to Engagements
          <ArrowRightIcon className="h-4 w-4" />
        </Link>
      </div>

      <div className="mt-6 bg-blue-50 border border-blue-200 rounded-lg p-4">
        <h3 className="text-sm font-medium text-blue-800 mb-2">Where to find documents:</h3>
        <ul className="text-sm text-blue-700 space-y-1">
          <li>• <strong>Client Documents:</strong> Go to Engagements → Select an engagement → Documents tab</li>
          <li>• <strong>Compliance Forms:</strong> Go to Compliance → Select a workflow</li>
        </ul>
      </div>
    </div>
  );
};

export default Documents;
